module.exports = __webpack_public_path__ + "static/addbookmark-24aabe75e76e668c71dc5ea554902586.png";